<template>
  <div
    class="tw:flex tw:w-full tw:items-center tw:gap-4 tw:px-4 tw:py-2 tw:text-sm tw:hover:bg-denim-100"
  >
    <div>
      <Checkbox
        dense
        :model-value="selected"
        new-design
        @update:model-value="emit('toggle', source)"
      />
    </div>
    <div>
      <img
        class="tw:w-12"
        :src="sourceLogo"
      />
    </div>
    <div class="tw:flex tw:flex-1 tw:flex-col tw:gap-1 tw:overflow-hidden">
      <div class="tw:text-base tw:font-bold">
        <EllipseContent>
          {{ source.name }}
        </EllipseContent>
      </div>
      <div class="tw:flex tw:max-w-max tw:gap-3">
        <div class="tw:flex tw:items-center tw:gap-1">
          <div
            class="tw:h-2 tw:w-2 tw:rounded-full"
            :class="{
              'tw:bg-media-online': source.medium === 'online',
              'tw:bg-media-print': source.medium === 'print',
              'tw:bg-media-tv': source.medium === 'tv',
              'tw:bg-media-magazine': source.medium === 'magazine',
              'tw:bg-media-radio': source.medium === 'radio',
              'tw:bg-media-podcast': source.medium === 'podcast',
              'tw:bg-media-social': source.medium === 'social',
            }"
          />

          {{ getMediumName(source.medium as MediumField) }}
        </div>
        <div class="tw:flex tw:items-center tw:gap-1">
          <BaseIcon
            class="tw:text-denim-600"
            icon="location"
          />

          {{ source.location }}
        </div>
        <div
          v-if="source.source_group"
          class="tw:flex tw:flex-1 tw:items-center tw:gap-1 tw:overflow-hidden"
        >
          <BaseIcon
            class="tw:text-denim-600"
            icon="folder"
          />

          <EllipseContent
            anchor="bottom end"
            class="tw:flex-1"
            self="top end"
          >
            {{ source.source_group.name }}
          </EllipseContent>
        </div>
      </div>
      <div class="tw:flex tw:max-w-max tw:items-center tw:gap-1">
        <BaseIcon
          class="tw:text-denim-600"
          icon="pie-chart"
        />

        <SourceListItemTopics
          v-if="isCisionOne && source.topics && source.topics.length"
          :topics="source.topics"
        />
        <div v-else-if="!isCisionOne && source.category">
          {{ source.category }}
        </div>
        <div v-else>-</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";

import { BaseIcon } from "shared/components/base";
import EllipseContent from "shared/components/base/EllipseContent.vue";
import Checkbox from "shared/components/core/forms/Checkbox.vue";
import type { MediumField } from "shared/helpers/media";
import { getSourceByField } from "shared/helpers/media";
import type { Source } from "shared/helpers/sourceFilters";
import useGlobalStore from "shared/stores/global";

import SourceListItemTopics from "./SourceListItemTopics.vue";

interface Props {
  source: Source;
  selected?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  toggle: [Source];
}>();

const globalStore = useGlobalStore();

const { isCisionOne } = storeToRefs(globalStore);

const sourceLogo = computed(
  () => props.source.logo_url || props.source.source_group?.logo_url || ""
);

function getMediumName(medium: MediumField) {
  return getSourceByField(medium).label;
}
</script>
